import { ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { recordRequestMetadata } from "./requestMetadata";

/**
 * Records which operation, endpoint and token a failed request used, so the
 * error can be classified and reported with that context. The error itself is
 * forwarded unchanged.
 *
 * `token` must be the token this link's request is sent with; Apollo.tsx
 * rebuilds the link whenever the token changes, so the closure value is exactly
 * the token that went out on the wire.
 */
export const requestMetadataLink = (
  token: string | null,
  endpoint: string
): ApolloLink =>
  onError(({ networkError, operation }) => {
    if (networkError) {
      recordRequestMetadata(networkError, {
        operation: operation.operationName,
        endpoint,
        sentToken: token,
      });
    }
  });
